module.exports = __webpack_public_path__ + "img/insecticidal-lamp.ac210f99.png";